import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsDropdownModule, ModalModule} from 'ngx-bootstrap';
import { HistoryDataGraphComponent } from './history-data-graph.component';
import { HistoryDataViewComponent } from './history-data-view.component';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        NgbPopoverModule,
        FormsModule,
    ],
  declarations: [
      HistoryDataGraphComponent,
      HistoryDataViewComponent
  ],
  exports: [
    HistoryDataGraphComponent,
      HistoryDataViewComponent
  ]
})
export class HistoryDataViewModel {
}
